import React from 'react';
import failure from '../../assets/images/failed.svg';

const Maintenance = () => {
    return (
        <div className="container">
            <div className="success-wrapper">
                <div className="success-cont">
                    <img src={failure} alt="" />
                    <h2 className="mb-3 mt-4">We&apos;ll be back soon!</h2>
                    <p>Site is currently under maintenance for scheduled updates. Please check back shortly.</p>
                </div>
            </div>
        </div>
    );
};

export default Maintenance;
